import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Courses } from "./components/courses";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Career } from "./components/career";
import { Contact } from "./components/contact";
import { WhatsAppChat } from "./components/WhatsAppChat";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 50, // Adjust this value based on your navbar height
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Courses data={landingPageData.Courses} />
      <Services data={landingPageData.Services} />
      <Testimonials data={landingPageData.Testimonials} />
      <Team data={landingPageData.Team} />
      <Career data={landingPageData.Career} />
      <Contact data={landingPageData.Contact} />
      <WhatsAppChat phone={landingPageData.Contact?.phone} />
    </div>
  );
};

export default App;
